export default function GetAdvType({ advType, typeIndex }) {
  const searchType = advType.find((adv) => adv.id == typeIndex);
  return searchType ? searchType.title : "מדיה לא מוגדרת";
}
